module.exports = __webpack_public_path__ + "img/page12.b642d12e.png";